import React, {useState} from "react";
import Header from "../components/header/Header";
import { Outlet } from "react-router-dom";
import Footer from "../components/footer/Footer";
import FooterFinal from "../components/footer/FooterFinal";

const AppLayout = () => {

  //set different background color for different article/section and cycle/rotate
  const COLOR_ARRAY = ["#fafaf2","#f3f3e0","#ececcd","#e5e5bb"]

  const [backGroundColor, setbackGroundColor] = useState("#fafaf2");  

  return (
    <>
      <Header />
      <main style={{backgroundColor: backGroundColor}} >
        <Outlet />
      </main>
      {/* <Footer /> */}
      <FooterFinal />      
    </>
  );
};

export default AppLayout;
